// This file was automatically generated and should not be edited.
// Generated by settings:constants. See SettingsConstantsCommand.php

export const Activity_Types = {
	DEFAULT_ACTIVITY_TYPE_ID_SETTING: 'default_activity_type_id',
	DEFAULT_AIRCALL_CALL_SETTING: 'aircall_default_call_activity_type_id',
	DEFAULT_AIRCALL_VOICEMAIL_SETTING: 'aircall_default_voicemail_activity_type_id',
	DEFAULT_CALLRAIL_CALL_SETTING: 'callrail_default_call_activity_type_id',
	DEFAULT_CALLRAIL_VOICEMAIL_SETTING: 'callrail_default_voicemail_activity_type_id',
	DEFAULT_CLICK_TO_CALL_ACTIVITY_TYPE_ID_SETTING: 'default_click_to_call_activity_type_id',
	DEFAULT_CLICK_TO_CALL_VOICEMAILS_ACTIVITY_TYPE_ID_SETTING: 'default_click_to_call_voicemails_activity_type_id',
	DEFAULT_DIALPAD_CALL_SETTING: 'dialpad_default_call_activity_type_id',
	DEFAULT_DIALPAD_VOICEMAIL_SETTING: 'dialpad_default_voicemail_activity_type_id',
	DEFAULT_KIXIE_CALL_SETTING: 'kixie_default_call_activity_type_id',
	DEFAULT_KIXIE_VOICEMAIL_SETTING: 'kixie_default_voicemail_activity_type_id',
	DEFAULT_RINGCENTRAL_CALL_SETTING: 'ringcentral_default_call_activity_type_id',
	DEFAULT_RINGCENTRAL_VOICEMAIL_SETTING: 'ringcentral_default_voicemail_activity_type_id',
	DEFAULT_SCHEDULER_ACTIVITY_TYPE_ID_SETTING: 'default_scheduler_activity_type_id',
	DEFAULT_VIRTUAL_MEETINGS_ACTIVITY_TYPE_ID_SETTING: 'default_virtual_meetings_activity_type_id',
};

export const Assistant = {
	SETTING_ASSISTANT_ID_DEV_EMAIL_SEQUENCE_AGENT: 'cm9n2fkrg0001rq7w3dumm0cq',
	SETTING_ASSISTANT_ID_DEV_LEAD_RESEARCH_AGENT: 'cmaco53tg0005n0ruvljuhlpj',
	SETTING_ASSISTANT_ID_DEV_SALES_OBJECTION_AGENT: 'cmaclqpsv001z12vuayvq1h7t',
	SETTING_ASSISTANT_ID_DEV_SALES_PROCESS_AGENT: 'cm9mys5eo0001122t7s0vksnq',
	SETTING_ASSISTANT_ID_PROD_EMAIL_SEQUENCE_AGENT: 'cmaquxhd7000112udg9df3ox1',
	SETTING_ASSISTANT_ID_PROD_LEAD_RESEARCH_AGENT: 'cmaqv2wdh000bhuidujk4uudf',
	SETTING_ASSISTANT_ID_PROD_SALES_OBJECTION_AGENT: 'cmaqv02ac000dxob8bz60qo6f',
	SETTING_ASSISTANT_ID_PROD_SALES_PROCESS_AGENT: 'cmaqusco40001bu8aiaxb5524',
};

export const CancellationInfo = {
	SETTING_NAME: 'nut_cancellationinfo_data',
};

export const ChurnInfo = {
	SETTING_NAME: 'nut_churninfo_data',
};

export const DashDao = {
	PERSISTED_DASHBOARD_ORDER_SETTING: 'dashboard_persisted_dash_order',
};

export const EmailTemplate = {
	STREET_ADDRESS_SETTING_NAME: 'company_physical_street_address',
};

export const Instance = {
	SETTINGS_KEY_TEMPLATES_INSTANCE_ID: 'nutshell_templates_instance_id',
};

export const Lead_AutoClose = {
	DEFAULT_SETTING_NAME: 'auto_close_lead_outcome_id',
};

export const Markets = {
	DEFAULT_SETTING_NAME: 'default_market_id',
};

export const Nut_Activation_BannerConst = {
	HAS_DISMISSED_ADMIN_LNL_SETTING_NAME: 'has_dismissed_demio_admin_lnl',
	HAS_DISMISSED_BASICS_SETTING_NAME: 'has_dismissed_demio_ns_basics',
	HAS_DISMISSED_IMPORT_DATA_SETTING_NAME: 'has_dismissed_import',
	HAS_DISMISSED_INTRO_SETTING_NAME: 'has_dismissed_demio_intro',
	HAS_DISMISSED_SALES_TRAINING_SETTING_NAME: 'has_dismissed_sales_training',
};

export const Nut_Auth_Mfa_Actions_Authenticate = {
	MFA_REQUIRED_FOR_ALL_USERS_SETTING_NAME: 'mfa_required_for_all_users',
};

export const Nut_Auth_WorkOS_WorkOs = {
	SETTINGS_KEY_WORKOS_DIRECTORY_SYNC_CONFIGURED: 'workos_directory_sync_configured',
	SETTINGS_KEY_WORKOS_DIRECTORY_SYNC_CURSOR: 'workos_directory_sync_cursor',
	SETTINGS_KEY_WORKOS_DIRECTORY_SYNC_DEFAULT_ROLE: 'workos_directory_sync_default_role',
	SETTINGS_KEY_WORKOS_ORG_ID: 'workos_organization_id',
	SETTINGS_KEY_WORKOS_ORG_ID_STAGING: 'workos_organization_id_staging',
	SETTINGS_KEY_WORKOS_SSO_CONFIGURED: 'workos_sso_configured',
	SETTINGS_KEY_WORKOS_SSO_REQUIRED: 'workos_sso_required',
};

export const Nut_Billing_BillingPage_Plan_Actions_SerializeBilling = {
	SETTINGS_NAME_PLAN_CACHE: 'billing_plan_cache',
};

export const Nut_Billing_BillingPage_Plan_NutshellAdvisorQualifications = {
	SUPPORT_OVERRIDE_SETTING_NAME: 'override_has_nutshell_advisor',
};

export const Nut_CallRail_UserAuthSettingsWrapper = {
	SETTINGS_NAME_ACCOUNT_IDS: 'callrail_account_ids',
	SETTINGS_NAME_API_KEY: 'callrail_api_key',
	SETTINGS_NAME_COMPANY_IDS: 'callrail_company_ids',
	SETTING_NAME_PHONE_NUMBERS: 'callrail_phone_numbers',
	SETTING_NAME_USER_EMAIL: 'callrail_user_email',
};

export const Nut_ContextDocument_ContextDocumentLimits = {
	SETTING_NAME_DOCUMENT_OVERRIDE: 'context_document_count_default',
	SETTING_NAME_TOKEN_OVERRIDE: 'context_document_tokens_default',
};

export const Nut_Dialpad_Auth = {
	SETTING_NAME_ACCESS_TOKEN: 'dialpad_access_token',
	SETTING_NAME_IS_SUPER_ADMIN: 'dialpad_is_super_admin',
	SETTING_NAME_PHONE_NUMBERS: 'dialpad_phone_numbers',
	SETTING_NAME_USERNAME: 'dialpad_username',
	SETTING_NAME_USER_ID: 'dialpad_user_id',
};

export const Nut_Em_DkimProvider = {
	SETTING_SYNTAX_PRIVATEKEY: 'dkim_%s',
	SETTING_SYNTAX_PUBLICKEY: 'dkim_%s_public',
};

export const Nut_Em_FromDomain_Actions_AutoSetCustomClickDomain = {
	SETTING_NAME: 'auto_set_custom_click_domain',
};

export const Nut_Em_Gate = {
	SETTING_EMAILS_SENT_THIS_MONTH_LIMIT: 'email_marketing_emails_sent_this_month_limit',
	SETTING_EMAILS_SENT_THIS_MONTH_LIMIT_EXPIRES: 'email_marketing_emails_sent_this_month_limit_expires',
	SETTING_EMAIL_LIMIT_OVERRIDE: 'email_marketing_email_limit_override',
	SETTING_NUM_MARKETABLE_CONTACTS_LIMIT: 'email_marketing_num_marketable_contacts_limit',
	SETTING_TIME_SENDING_DISABLED: 'email_marketing_time_sending_disabled',
};

export const Nut_Embed_Actions_CustomerSiteConfigFetch = {
	CUSTOMER_SITE_CONFIG_SETTING: 'customer_site_config',
};

export const Nut_Embed_SnippetTestStatusSetting = {
	SETTING_NAME: 'embedded_snippet_status_test',
};

export const Nut_FacebookMessenger_Actions_HandleDataDelete = {
	DATA_DELETE_REQUEST_SETTING_PREFIX: 'facebook_data_delete_',
};

export const Nut_Feedback_Feedback = {
	SETTING_PREFIX: 'internal_feedback_',
};

export const Nut_FraudScore_Evaluators_ManualReview = {
	SETTING_NAME: 'em_editions_require_review',
};

export const Nut_Google_Actions_MeetWebhooksSubscribe = {
	SETTINGS_NAME_GMEET_USER_ID: 'google_meet_user_id',
};

export const Nut_Import_Dromo_Client = {
	SETTINGS_FRONTEND_API_KEY: 'e201ffda-d3d8-4428-9e4b-9bbb94dc9ad8',
};

export const Nut_Inbox_Actions_GetAvailableNumbers = {
	NUMBER_COUNTRY_CODE_SETTING: 'inbox_number_country_code',
};

export const Nut_Inbox_Actions_InboundRulesGetOrCreate = {
	FACEBOOK_SETTING_NAME: 'inbound_messenger_rules',
	SMS_SETTING_NAME: 'inbound_sms_rules',
	WHATSAPP_SETTING_NAME: 'inbound_whatsapp_rules',
};

export const Nut_Inbox_Actions_InboxGetEffectiveStatus_EngagementCapabilities = {
	PLAY_ENGAGEMENT_NOTIFICATION_SOUNDS_SETTING_NAME: 'play_engagement_notification_sounds',
	SKU_SETTINGS_NAME: 'plan_inbox_sku',
	SKU_TRIAL_EXPIRES_SETTING_NAME: 'plan_inbox_sku_expires',
};

export const Nut_Inbox_Chat_Actions_ChatConfigGetOrCreate = {
	CONFIG_SETTING_NAME: 'chat_config',
};

export const Nut_Inbox_Chat_Actions_Chatbot_ChatbotPromptBuilder = {
	CHATBOT_BASE_PROMPTS_CACHE_SETTING_NAME: 'chatbot_base_prompts_cache',
	CONTEXT_DOCUMENTS_CACHE_SETTING_NAME: 'context_documents_cache',
};

export const Nut_Inbox_Chat_Actions_Chatbot_ScrapedDataGetOrCreate = {
	CHAT_SCRAPED_DATA_SETTING_NAME: 'chat_scraped_data',
	CHAT_SCRAPED_DATA_URLS_SETTING_NAME: 'chat_scraped_data_urls',
	SCRAPE_STATE_SETTING_NAME: 'scrape_state',
};

export const Nut_Inbox_InboxCredits = {
	SETTING_NAME_OVERRIDE_PER_MONTH: 'inbox_credits_default_per_month',
	SETTING_NAME_TIME_UNTIL_OVERRIDE_EXIRES: 'inbox_credits_override_expires',
};

export const Nut_Inbox_Sms_EnrollmentForm = {
	FORM_SETTINGS_KEY: 'inbox_enrollment_form',
};

export const Nut_Lead_Research_Prompts_ResearchPrompt = {
	SETTING_BUSINESS_CONTEXT: 'lead_research_business_context',
	SETTING_IDEAL_CUSTOMER: 'lead_research_ideal_customer',
	SETTING_SELECTED_FIELDS: 'lead_research_selected_fields',
};

export const Nut_Lp_Actions_InsertDynamicScripts = {
	DISABLE_MCFX_TRACKING_SETTING_NAME: 'landing_pages_disable_mcfx_tracking',
	GTM_ID_SETTING_NAME: 'landing_pages_gtm_id',
};

export const Nut_OneOff_Rbac_MigrateToRbacPermissions = {
	SETTING_CAN_ACCESS_EMAIL_MARKETING: 'can_access_email_marketing',
};

export const Nut_PhoneIntegrations_AircallIntegration = {
	SETTING_NAME_SYNC_PAST_CALLS: 'aircall_should_sync_past_calls',
};

export const Nut_PhoneIntegrations_CallRailIntegration = {
	SETTING_NAME_SYNC_PAST_CALLS: 'callrail_should_sync_past_calls',
};

export const Nut_PhoneIntegrations_DialpadIntegration = {
	SETTING_NAME_SYNC_PAST_CALLS: 'dialpad_should_sync_past_calls',
};

export const Nut_PhoneIntegrations_RingCentralIntegration = {
	SETTING_NAME_SYNC_PAST_CALLS: 'ringcentral_should_sync_past_calls',
};

export const Nut_PowerAi_Actions_GetMonthlyTranscriptionsByUser = {
	CURRENT_MONTH_SETTING_NAME: 'powerai_transcriptions_this_month',
	ROLLUP_SETTING_NAME: 'powerai_transcriptions_rollup',
};

export const Nut_Proc_Steps_HardDeleteCleanup = {
	SETTINGS_PREFIX: 'proc_steps_hard_deleted_',
};

export const Nut_RingCentral_Auth = {
	SETTINGS_NAME_ACCESS_TOKEN: 'ringcentral_access_token',
	SETTINGS_NAME_EXTENSION_NUMBER: 'ringcentral_extension_number',
	SETTINGS_NAME_IS_ENABLED: 'ringcentral_is_enabled',
	SETTINGS_NAME_PHONE: 'ringcentral_phones',
	SETTINGS_NAME_USERNAME: 'ringcentral_username',
	SETTINGS_NAME_WEBHOOK_VERIFICATION_TOKEN: 'ringcentral_webhook_verification_token',
};

export const Nut_Security_Actions_SecurityUpdateSettings = {
	EMAIL_ACLS_SETTING: 'is_strict_email_acls',
	USER_SESSION_LENGTH_SETTING: 'user_session_length',
};

export const Nut_Settings_Instance = {
	SETTING_COMPANY_DISPLAY_NAME: 'company_display_name',
};

export const Nut_Settings_User = {
	SETTING_AI_AGENT_SIDEBAR_OPEN: 'ai_agent_sidebar_open',
	SETTING_ALL_CHANNELS_INBOX_FILTER_IDS: 'all_channels_inbox_filter_ids',
	SETTING_AUTO_PRESENCE_ENABLED: 'auto_presence_enabled',
	SETTING_C2C_AUDIO_RECORDING_ENABLED: 'c2c_audio_recording_enabled',
	SETTING_C2C_SUMMARY_ENABLED: 'c2c_summary_enabled',
	SETTING_C2C_TRANSCRIPTION_ENABLED: 'c2c_transcription_enabled',
	SETTING_CHAT_INBOX_FILTER_IDS: 'chat_inbox_filter_ids',
	SETTING_CUE_CARD_DISMISSED_PREFIX: 'cuehide_',
	SETTING_EXCLUDE_TIMELINE_CUSTOMER_JOURNEYS: 'timeline_persisted_exclude_customer_journeys',
	SETTING_EXCLUDE_TIMELINE_INTERACTION_EVENTS: 'timeline_persisted_exclude_interactions',
	SETTING_EXCLUDE_TIMELINE_OUTREACH_EVENTS: 'timeline_persisted_exclude_outreach',
	SETTING_HAS_ALLOWED_GOOGLE_MEET_WEBHOOK_PROCESSING: 'has_allowed_google_meet_webhook_processing',
	SETTING_HAS_CHANGED_AGENT_STATUS: 'has_changed_agent_status',
	SETTING_HAS_DISMISSED_ADTECH_FX_MODAL: 'has_dismissed_adtech_fx_modal',
	SETTING_HAS_DISMISSED_AI_HOMEPAGE_ONBOARDING_MODAL: 'has_dismissed_ai_homepage_onboarding_modal',
	SETTING_HAS_DISMISSED_EMAIL_EDITOR_QUOTE_LINK_INFO: 'cuehide_has_dismissed_email_editor_quote_link_info',
	SETTING_HAS_DISMISSED_ENGAGEMENT_REPORT_BANNER: 'has_dismissed_engagement_report_banner',
	SETTING_HAS_DISMISSED_INBOX_DASHBOARD_CHECKLIST: 'has_dismissed_inbox_dashboard_checklist',
	SETTING_HAS_DISMISSED_LEAD_FOLLOWUP_ONBOARDING: 'has_dismissed_lead_followup_onboarding',
	SETTING_HAS_DISMISSED_MARKETING_DASHBOARD_CHECKLIST: 'has_dismissed_marketing_dashboard_checklist',
	SETTING_HAS_DISMISSED_ONBOARDING_SIDEBAR: 'has_dismissed_onboarding_sidebar',
	SETTING_HAS_DISMISSED_SIGNUP_CHECKLIST: 'has_dismissed_signup_checklist',
	SETTING_HAS_DISMISSED_STATUS_FOLLOWUP: 'cuehide_has_dismissed_status_followup',
	SETTING_HAS_DISMISSED_TASK_REPORT_BANNER: 'has_dismissed_task_report_banner',
	SETTING_HAS_DISMISSED_TEXT_MESSAGING_ONBOARDING: 'has_dismissed_text_messaging_onboarding',
	SETTING_HAS_DISMISSED_WHATSAPP_SYNC_STATUS_BANNER: 'cuehide_has_dismissed_whatsapp_sync_status_banner',
	SETTING_HAS_ENABLED_AIRCALL_AUTOLOG: 'has_enabled_aircall_autolog',
	SETTING_HAS_ENABLED_CALLRAIL_AUTOLOG: 'has_enabled_callrail_autolog',
	SETTING_HAS_ENABLED_DIALPAD_AUTOLOG: 'has_enabled_dialpad_autolog',
	SETTING_HAS_ENABLED_GOOGLE_MEET_AUTOLOG: 'has_enabled_google_meet_autolog',
	SETTING_HAS_ENABLED_KIXIE_AUTOLOG: 'has_enabled_kixie_autolog',
	SETTING_HAS_ENABLED_MICROSOFT_TEAMS_AUTOLOG: 'has_enabled_microsoft_teams_autolog',
	SETTING_HAS_ENABLED_RINGCENTRAL_AUTOLOG: 'has_enabled_ringcentral_autolog',
	SETTING_HAS_ENABLED_ZOOM_AUTOLOG: 'has_enabled_zoom_autolog',
	SETTING_HAS_SKIPPED_CHAT_ONBOARDING: 'has_skipped_chat_onboarding',
	SETTING_HAS_USER_VISITED_AI_HOMEPAGE: 'has_user_visited_ai_homepage',
	SETTING_HAS_VIEWED_LEAD_CUSTOMIZE_PAGE: 'has_viewed_lead_customize_page',
	SETTING_HAS_VIEWED_PROSPECTOR_ONBOARDING: 'has_viewed_prospector_onboarding',
	SETTING_HAS_VIEWED_SALES_AUTOMATION_LEAD_FOLLOWUP: 'has_viewed_sales_automation_lead_followup',
	SETTING_HAS_VIEWED_TEXT_MESSAGE_ONBOARDING: 'has_viewed_text_message_onboarding',
	SETTING_HIDE_CIQ_COMING_SOON_OPT_IN: 'hide_ciq_coming_soon_opt_in',
	SETTING_HIDE_COMPANY_UNLOCK_CONFIRMATION: 'hide_company_unlock_confirmation',
	SETTING_HIDE_DMARC_REQUIRED_CTA: 'hide_dmarc_required_cta',
	SETTING_HIDE_EMAIL_REPORT_VIA_TEMPLATE_GROUPS: 'hide_email_report_via_template_groups',
	SETTING_HIDE_M3_LEAD_PAGE_ONBOARDING_MODAL: 'hide_m3_lead_page_onboarding_modal',
	SETTING_HIDE_NEW_LEAD_PAGE_ONBOARDING_MODAL: 'hide_new_lead_page_onboarding_modal',
	SETTING_HIDE_SCHEDULER_ONBOARDING_MODAL: 'hide_scheduler_onboarding_modal',
	SETTING_HIDE_SCHEDULER_PROMOTION: 'hide_scheduler_promotion',
	SETTING_HIDE_TEMPLATE_GROUPS_VIA_EMAIL_REPORT: 'hide_template_groups_via_email_report',
	SETTING_INSTAGRAM_INBOX_FILTER_IDS: 'instagram_inbox_filter_ids',
	SETTING_INTERNAL_FEEDBACK_DISMISSED_PREFIX: 'has_dismissed_internal_feedback_',
	SETTING_LEAD_PAGE_ACTION_BAR_TAB: 'lead_page_action_bar_tab',
	SETTING_LEAD_PAGE_ACTIVITY_FILTER_IDS: 'lead_page_activity_filter_ids',
	SETTING_LEAD_PAGE_REDESIGN_M1_ENABLED: 'lead_page_redesign_m1_enabled',
	SETTING_LEAD_PAGE_REDESIGN_M3_ENABLED: 'lead_page_redesign_m3_enabled',
	SETTING_LEAD_PAGE_REDESIGN_M3_SWAPPER_USER: 'has_lead_page_redesign_m3_swapper_user',
	SETTING_LEAD_PAGE_TASK_MODE: 'lead_page_task_mode',
	SETTING_LEAD_WORKSPACE_SIDEBAR_COLLAPSED: 'lead_page_workspace_sidebar_collapsed',
	SETTING_MAIN_SIDEBAR_COLLAPSED: 'main_sidebar_collapsed',
	SETTING_MESSENGER_INBOX_FILTER_IDS: 'messenger_inbox_filter_ids',
	SETTING_SHORTCUTS_DISABLED: 'shortcuts_disabled',
	SETTING_SMS_INBOX_FILTER_IDS: 'sms_inbox_filter_ids',
	SETTING_TOUR_COMPLETED_LEAD_BOARD: 'tour_completed_lead_board',
	SETTING_TOUR_COMPLETED_LEAD_REPORTS: 'tour_completed_lead_reports',
	SETTING_TOUR_COMPLETED_SAVED_LIST: 'tour_completed_saved_list',
	SETTING_WHATSAPP_INBOX_FILTER_IDS: 'whatsapp_inbox_filter_ids',
	SETTING_WIDGET_LEAD_ATTACHMENTS_COLLAPSED: 'widget_lead_attachments_collapsed',
	SETTING_WIDGET_LEAD_CHANNELS_AND_SOURCES_COLLAPSED: 'widget_lead_channels_and_sources_collapsed',
	SETTING_WIDGET_LEAD_COMPANIES_AND_PEOPLE_COLLAPSED: 'widget_lead_companies_and_people_collapsed',
	SETTING_WIDGET_LEAD_COMPETITORS_COLLAPSED: 'widget_lead_competitors_collapsed',
	SETTING_WIDGET_LEAD_COMPLETED_TASKS_COLLAPSED: 'widget_lead_completed_tasks_collapsed',
	SETTING_WIDGET_LEAD_CUSTOM_FIELDS_COLLAPSED: 'widget_lead_custom_fields_collapsed',
	SETTING_WIDGET_LEAD_DRIP_SEQUENCES_COLLAPSED: 'widget_lead_drip_sequences_collapsed',
	SETTING_WIDGET_LEAD_FUTURE_TASKS_COLLAPSED: 'widget_lead_future_tasks_collapsed',
	SETTING_WIDGET_LEAD_LOGGED_ACTIVITIES_COLLAPSED: 'widget_lead_logged_activities_collapsed',
	SETTING_WIDGET_LEAD_PERSONAL_EMAIL_SEQUENCES_COLLAPSED: 'widget_lead_personal_email_sequences_collapsed',
	SETTING_WIDGET_LEAD_PIPELINE_COLLAPSED: 'widget_lead_pipeline_collapsed',
	SETTING_WIDGET_LEAD_PRODUCTS_COLLAPSED: 'widget_lead_products_collapsed',
	SETTING_WIDGET_LEAD_SALES_DOCUMENTS_COLLAPSED: 'widget_lead_sales_documents_collapsed',
	SETTING_WIDGET_LEAD_SCHEDULED_ACTIVITIES_COLLAPSED: 'widget_lead_scheduled_activities_collapsed',
	SETTING_WIDGET_LEAD_TOP_CUSTOM_FIELDS_COLLAPSED: 'widget_lead_top_custom_fields_collapsed',
	SETTING_WIDGET_LEAD_UPCOMING_TASKS_COLLAPSED: 'widget_lead_upcoming_tasks_collapsed',
};

export const Nut_Summarization_PipelineV2_Prompts_LeadVersion = {
	AI_LEAD_SUMMARY_GENERATOR_VERSION_SETTING_NAME: 'ai_lead_summary_generator_version',
};

export const Nut_UserIntegration_Zoom = {
	SETTING_ERROR_NAME: 'zoom_integration_error',
};

export const Nut_WebFx_Billing_Actions_GetOrFetchFxPlan = {
	FX_SETTINGS_NAME: 'fx_plan',
};

export const Nut_WebFx_Mcfx_CompanyTracker_Actions_GetIndustryAllowlist = {
	BLOCKLIST_SETTING_NAME: 'mcfx_ct_blocklist',
};

export const Nut_WebFx_Mcfx_CompanyTracker_Actions_GetIndustryBlocklist = {
	BLOCKLIST_SETTING_NAME: 'mcfx_ct_blocklist',
};

export const Nut_WebFx_Mcfx_CompanyTracker_FilterEnum = {
	SETTING_NAME_CONTACTINFORMATION: 'filter_contact_info',
	SETTING_NAME_JOBFIELD: 'filter_job_field',
	SETTING_NAME_MANAGEMENTLEVEL: 'filter_management_level',
	SETTING_NAME_PEOPLEIQ_PREFIX: 'mcfx_piq_',
	SETTING_NAME_VISITORIQ_PREFIX: 'mcfx_ct_',
};

export const Nut_WebFx_Mcfx_CompanyTracker_UnlockCounter = {
	SETTING_NAME_OVERRIDE_PER_MONTH: 'company_tracker_default_per_month',
	SETTING_NAME_TIME_UNTIL_OVERRIDE_EXIRES: 'company_tracker_override_expires',
	SETTING_NAME_UNLOCKS_USED_THIS_MONTH: 'company_tracker_unlocks_used',
};

export const Nut_WebFx_Mcfx_Enrichment_Actions_GetAccountEnrichmentData = {
	ENRICHMENT_DISABLED_SETTING_NAME: 'is_company_enrichment_disabled',
	NUTSHELL_INTELLIGENCE_DISABLED_SETTING_NAME: 'is_nutshell_intelligence_disabled',
};

export const Nut_WebFx_Mcfx_Webhook_Handler = {
	SETTING_LOG_REQUEST: 'webfx_webhook_debug',
};

export const Nut_Zoom_Auth = {
	SETTING_NAME: 'zoom_oauth_token',
};

export const Nut_Zoom_Client = {
	SETTING_HOST_ID: 'zoom_host_id',
	ZOOM_USERNAME_SETTINGS_KEY: 'zoom_username',
};

export const Nut_AccountInfoCache = {
	SETTINGS_NAME: 'account_info',
};

export const Nut_Analytics = {
	IGNORE_ANALYTICS_SETTING_NAME: 'ignore_analytics',
	TRACK_ACCOUNT_SETTING_CHANGE: 'account_setting_changed',
	TRACK_SETTING_NUTSHELL_INTELLIGENCE_DISABLED: 'setting_nutshell_intelligence_disabled',
	TRACK_SETTING_NUTSHELL_INTELLIGENCE_ENABLED: 'setting_nutshell_intelligence_enabled',
};

export const Nut_Api_JsonInternal = {
	SETTINGS_API_PREFIX_ALLOWLIST: 'feature_',
};

export const Nut_Auth_Strategy_WebFx = {
	ALLOW_WEBFX_LOGIN_SETTING_NAME: 'allow_webfx_login',
};

export const Nut_Calendar_Sync = {
	IMPORT_SETTING_NAME: 'calendar_import_enabled',
};

export const Nut_Capabilities = {
	ADAPTIVE_SALES_PROCESS_MIGRATION_NUT_8141_SETTINGS_NAME: 'has_process_template_migration_NUT-8141',
	AI_AGENTS_HIDE_SETTING_NAME: 'hide_ai_agents',
	AI_EMAIL_REPLIES_HIDE_SETTING_NAME: 'hide_ai_email_replies',
	AI_LIVE_NOTE_TRANSCRIPTION_HIDE_SETTING_NAME: 'hide_ai_live_note_transcription',
	AI_SUMMARY_GENERATOR_VERSION_SETTING_NAME: 'ai_summary_generator_version',
	AI_SUMMARY_HIDE_SETTING_NAME: 'hide_ai_summarization',
	ALLOW_ACH_SETTINGS_NAME: 'allow_ach_billing',
	ALLOW_CLASSIC_PLAN_SETTINGS_NAME: 'can_have_classic',
	BOOKING_REMINDERS_ENABLED_SETTING_NAME: 'booking_reminders_enabled',
	CF_SIGNUP_FORMS_SETTING_NAME: 'mcfx_signup_form_ids',
	DEMO_SILO_SETTINGS_NAME: 'has_demo_silos',
	DRIP_MIGRATION_NUT_9409_SETTINGS_NAME: 'enable_drip_NUT-9409',
	DUPLICATE_DETECTION_MODE_BETA_SETTINGS_NAME: 'has_duplicate_detection_mode_beta',
	ENABLE_NUT_8510_REST_ACTIVITY_PARTICIPANT_WORKAROUND_SETTINGS_NAME: 'enable_nut_8510_rest_workaround_NUT-8141',
	FETCH_TODOS_FROM_DB_SETTINGS_NAME: 'fetch_todos_from_db_NUT-8589',
	FETCH_TODOS_FROM_SOLR_SETTINGS_NAME: 'fetch_todos_from_solr_NUT-8589',
	FUNNEL_BETA_SETTINGS_NAME: 'has_funnel_report_beta',
	HAS_CHANNELS_SETTING_NAME: 'has_channels',
	HAS_CUSTOMER_JOURNEYS_SETTING_NAME: 'has_customer_journeys',
	HAS_FORM_MAPPING_SETTING_NAME: 'has_form_mapping',
	HAS_HACK_DAY_01_2023_LIST_FIELDS_SETTING_NAME: 'has_hack_day_01_2023_list_fields',
	HAS_NEW_AUDIENCE_MANAGEMENT_SETTING_NAME: 'has_new_audience_management_enabled',
	HAS_NEW_CTA_BANNERS_SETTING_NAME: 'has_new_cta_banners',
	HAS_SCHEDULER_SETTING_NAME: 'has_scheduler',
	HIDE_TODO_EXPLAINER_SETTINGS_NAME: 'hide_todo_explainer_NUT-4536',
	IFRAME_DASH_NAME_SETTING: 'dashboard_iframe_dash_name',
	IFRAME_DASH_URL_SETTING: 'dashboard_iframe_dash_url',
	INCEPTION_DATE_SETTINGS_NAME: 'inception_date',
	MARKDOWNHTML_MIGRATION_SETTINGS_NAME: 'enable_htmail',
	NA_TRIAL_EXPIRES_SETTING_NAME: 'plan_nutshelladvisor_sku_expires',
	NEW_SETTINGS_NAV_DATE: '2025-10-01',
	OMIT_LANDING_PAGES_CSP_SETTING_NAME: 'omit_landing_pages_csp',
	PLAN_TRIAL_EXPIRE_DATE_SETTINGS_NAME: 'plan_trial_expire_date',
	PLAN_TRIAL_SKU_SETTINGS_NAME: 'plan_trial_sku',
	PROHIBIT_ACH_BILLING_SETTINGS_NAME: 'prohibit_ach_billing',
	QT_TRIAL_EXPIRES_SETTING_NAME: 'plan_quotes_sku_expires',
	RB_TRIAL_EXPIRES_SETTING_NAME: 'plan_revenuebooster_sku_expires',
	REACT_LEAD_PAGE_SETTINGS_NAME: 'has_react_lead_page',
	REPORT_FORECAST_BETA_SETTINGS_NAME: 'has_forecast_report_beta',
	SALES_PROCESS_SETUP_NUT_7581_SETTINGS_NAME: 'has_sales_process_setup_NUT-7581',
	SETTINGS_NAME_TASK_LIST_INDEX_HINTING: 'has_task_list_index_hinting',
	SKU_ADDITIONAL_SMS_CREDITS_SETTINGS_NAME: 'plan_additional_sms_credits_sku',
	SKU_NUTSHELL_ADVISOR_SETTINGS_NAME: 'plan_nutshelladvisor_sku',
	SKU_QUOTES_SETTINGS_NAME: 'plan_quotes_sku',
	SKU_REVENUE_BOOSTER_SETTINGS_NAME: 'plan_revenuebooster_sku',
	SKU_SETTINGS_NAME: 'plans_sku',
	SKU_VISITOR_IQ_SETTINGS_NAME: 'plan_visitoriq_sku',
	STAGE_GATED_STEPS_OPTOUT_SETTINGS_NAME: 'stage_gated_steps_optout_NUT-8804',
	USE_TODO_LIST_WITH_GATED_STEPS_SETTINGS_NAME: 'feature_use_todo_list_with_gated_steps_NUT-4536',
	VISUAL_PIPELINE_NUT_5610_ENABLED_SETTINGS_NAME: 'has_visual_pipeline_NUT-5610',
};

export const Nut_DripMigrator = {
	DRIP_MIGRATION_HIGHEST_SEQUENCE_ID_REFRESHED_SETTINGS_NAME: 'drip_migration_highest_sequence_id_refreshed',
};

export const Nut_EmailMarketingSpike = {
	BEE_EDITOR_TEMPLATE_JSON_SETTING_NAME: 'bee_editor_template_json',
};

export const Nut_Gearman_Worker_SolrBackground = {
	DELAY_ALL_SETTING_NAME: 'delay_all_solr',
};

export const Nut_Google_CalendarSync = {
	SETTINGS_ENABLED: 'google_sync_calendar_enabled',
};

export const Nut_Google_Directory = {
	SETTING_SYNC_ERROR_SENT_KEY: 'google_usersync_error_email_sent',
};

export const Nut_Import_AccountContactCsv = {
	SETTING_IMPORTER_CONTACTS_PER_ACCOUNT_MAX: 'account_contact_csv_max_contacts_per_account',
};

export const Nut_InitialContentHandler = {
	DEMO_FINISHED_LOADING_DATA_SETTING_NAME: 'demoFinishedLoadingData',
};

export const Nut_Mail_Protocol_Smtp = {
	SETTING_GLOBAL_DISABLE_VERIFY: 'global_smtp_disable_verify',
};

export const Nut_Mail_Sync = {
	SETTINGS_ALL: 'all',
	SETTINGS_ENABLED: 'enabled',
	SETTINGS_INITIAL_SYNC_CREATE_CONTACTS: 'initial_sync_create_contacts',
	SETTINGS_INITIAL_SYNC_NUM_DAYS: 'initial_sync_num_days_ago',
	SETTINGS_SHARE_DEFAULT: 'share_default',
	SETTINGS_SYNC_ALL_EMAIL_MESSAGES: 'sync_all_user_email_messages',
	SETTINGS_SYNC_MAIL_RESYNC_STATE: 'sync_mail_resync',
};

export const Nut_Mail_Sync_Office365 = {
	SETTINGS_SYNC_MAIL_STATE: 'sync_mail_bookmark',
	SETTINGS_SYNC_START_TIME: 'time_enabled',
	SETTINGS_SYNC_STATE: 'sync_bookmarks',
};

export const Nut_Mail_UserSmtpCredentials = {
	SETTING_DISABLE_VERIFY: 'disable_verify',
	SETTING_PREFIX: 'smtp_',
	SETTING_STATUS_FAILED_MESSAGE: 'failed_message',
};

export const Nut_Mailchimp_OAuth = {
	SETTING_ACCESS_TOKEN: 'mailchimp_access_token',
};

export const Nut_Office365_Auth = {
	GRAPH_TOKEN_SETTINGS_NAME: 'office365_graph_token',
};

export const Nut_PauseInfo = {
	SETTING_NAME: 'nut_pauseinfo_data',
};

export const Nut_PhoneCaller = {
	INSTANCE_SETTING_API_KEY: 'phonecaller_apikey',
	INSTANCE_SETTING_API_SECRET: 'phonecaller_apisecret',
	SETTING_NAME_ALLOW_INTERNATIONAL_C2C_TRIAL: 'allow_international_c2c_trial',
	SETTING_NAME_C2C_CUSTOMER_INSTANCE_VERIFIED: 'c2c_customer_instance_verified',
	SETTING_NAME_CID_NUMBER_ATTEMPTS_IN_TRIAL: 'cid_number_attempts_in_trial',
	SETTING_NAME_TOTAL_CALLS_PER_TRIAL: 'total_calls_per_trial',
	SETTING_NAME_TOTAL_CALLS_PER_USER_IN_TRIAL: 'total_calls_per_user_in_trial',
	SETTING_NAME_TOTAL_CID_NUMBERS_IN_TRIAL: 'total_cid_numbers_in_trial',
	SETTING_NAME_TOTAL_CID_NUMBER_ATTEMPTS_IN_TRIAL: 'total_cid_number_attempts_in_trial',
	USER_SETTING_CALLERID_KEY: 'phonecaller_callerid',
	USER_SETTING_KEY: 'phonecaller_number',
	USER_TYPE_SETTINGS_KEY: 'phonecaller_type',
};

export const Nut_ReportView = {
	SETTING_PREFIX: 'report_recent_view_',
};

export const Nut_SalesAutomationMigrator = {
	SETTING_STATUS_NAME: 'sales_automation_migrator',
};

export const Nut_Service_Twitter = {
	SETTINGS_KEY: 'twitter_access_credentials',
};

export const Nut_SignupInfo = {
	SETTING_NAME: 'nut_signupinfo_data',
};

export const Nut_Silo = {
	SETTING_PARENT_ID: 'demo_silo_parent_id',
	SETTING_PARENT_USER_ID: 'demo_silo_parent_user_id',
	SETTING_USER_PREFIX: 'demo_silo_user_',
};

export const Nut_Sync_Client_Office365 = {
	SETTINGS_CALENDARS_PREFIX: 'calendar_sync_office365',
	SETTINGS_CALENDARS_TOKENS: 'tokens',
	SETTINGS_CONTACTS_TOKENS: 'tokens',
};

export const NutshellBilling_Subscription_MarketingCapabilities = {
	SKU_MARKETING_CAMPAIGNS_SETTINGS_NAME: 'plan_marketing_sku',
	SKU_SETTINGS_NAME: 'plan_marketingsuite_sku',
};

export const User = {
	SETTING_CAN_ACCESS_EMAIL_MARKETING: 'can_access_email_marketing',
	SETTING_HAS_DISMISSED_ONBOARDING_SIDEBAR: 'has_dismissed_onboarding_sidebar',
	SETTING_HIDE_FROM_FILTERS: 'hide_from_filters',
	SETTING_PASSWORD_CHANGE_TIME: 'last_password_change_time',
	SETTING_PAUSE_AUTOMATED_EMAILS: 'pause_automated_emails',
};

export const User_GoogleApiAccountMap = {
	SETTING_LAST_CALENDAR_FETCH: 'lastcalendarfetch',
};

export const application_models_AiAssistant_Conversations_Limits = {
	BULK_EMAIL_RECIPIENT_LIMIT_SETTING: 'limit_bulk_email_recipients',
	BULK_EMAIL_RECIPIENT_LIMIT_TRIAL_SETTING: 'limit_bulk_email_recipients_trial',
};

export const application_models_Context_Documents = {
	PRIMARY_CONTEXT_DOCUMENT_ID_SETTING_NAME: 'primary_context_document_id',
};

export const application_models_Em_Comparison = {
	SETTING_MEMBER_KEY: 'send_to_comparison_last_member_id',
};

export const application_models_Em_FromDomain_OnboardingWizards = {
	SETTING_ADD_TO_AUDIENCE_MODAL_HIDDEN: 'has_dismissed_add_to_audience_modal',
	SETTING_CUSTOM_PLACEHOLDER_ONBOARDING: 'has_viewed_custom_placeholder_onboarding_NUT-10739',
	SETTING_DISMISSED_DEFAULT_STAGESET_WIZARD_CTA_LEAD_BOARD: 'has_dismissed_stageset_wizard_cta_lead_board_NUT-8926',
	SETTING_DISMISSED_DEFAULT_STAGESET_WIZARD_CTA_LEAD_PAGE: 'has_dismissed_stageset_wizard_cta_lead_page_NUT-8926',
	SETTING_DISMISSED_OR_COMPLETED_SA_TEMPLATE_DOWNLOAD: 'has_closed_sa_template_download',
	SETTING_EMAIL_DRIP_MODAL_ONBOARDING: 'has_viewed_drip_modal_onboarding_NUT-10011',
	SETTING_EMAIL_DRIP_VIDEO_ONBOARDING: 'has_dismissed-drip-video-10372',
	SETTING_EMAIL_MARKETING_ABOUT_DRIP_SEQUENCES_MODAL_VIEWED: 'has_viewed_email_marketing_about_drip_sequences_modal',
	SETTING_EMAIL_MARKETING_LIFTING_OF_THE_CURTAIN_VIEWED: 'has_viewed_email_marketing_lifting_of_the_curtain',
	SETTING_EMAIL_MARKETING_LIFTING_OF_THE_CURTAIN_VIEWED_CTA: 'has_viewed_email_marketing_lifting_of_the_curtain_cta',
	SETTING_EMAIL_MARKETING_ONBOARDING_CHECKLIST_HIDDEN: 'has_dismissed_email_marketing_signup_checklist',
	SETTING_EMAIL_MARKETING_ONBOARDING_CHECKLIST_MINIMIZED: 'has_minimized_email_marketing_signup_checklist',
	SETTING_EMAIL_SEQUENCE_TEMPLATE_ONBOARDING: 'has_viewed_sequence_template_onboarding_NUT-10290',
	SETTING_INITIAL_TIMEZONE_SET: 'has_set_initial_timezone',
	SETTING_ONBOARDING_CHECKLIST_HIDDEN: 'has_dismissed_signup_checklist',
	SETTING_ONBOARDING_CHECKLIST_MINIMIZED: 'has_minimized_signup_checklist',
	SETTING_ONBOARDING_COMPANY_TYPE_AUTOMATION: 'has_viewed_onboarding_sales_automation_company_types_NUT-10534',
	SETTING_ONBOARDING_DEFAULT_STAGESET_WIZARD_RAN: 'onboarding_default_stageset_wizard_ran',
	SETTING_ONBOARDING_DEFAULT_STAGESET_WIZARD_VIEWED: 'onboarding_default_stageset_wizard_viewed',
	SETTING_ONBOARDING_DEMO_DASH: 'has_viewed_onboarding_demo_dash',
	SETTING_ONBOARDING_FUNNEL_DASHBOARD: 'has_viewed_onboarding_funnel',
	SETTING_ONBOARDING_IMPORT_UNSUBSCRIBED_WARNING_DISMISSED: 'has_dismissed_import_unsubscribed_warning',
	SETTING_ONBOARDING_SALES_AUTOMATION_PIPELINE_RAN: 'has_viewed_onboarding_sales_automation_pipeline_NUT-9087',
	SETTING_ONBOARD_GOOGLE_VIEWED: 'has_viewed_onboard_google',
	SETTING_ONBOARD_VIEWED: 'has_viewed_onboard_welcome',
	SETTING_WEB_FORMS_LIFTING_OF_THE_CURTAIN_VIEWED: 'has_viewed_web_forms_lifting_of_the_curtain',
};

export const application_models_Integration_Aircall = {
	SETTING_NAME_EMAIL: 'aircall_email',
	SETTING_NAME_NUMBERS: 'aircall_numbers',
	SETTING_NAME_USER_ID: 'aircall_user_id',
};

export const application_models_Integration_FacebookMessenger = {
	SETTINGS_NAME_AUTH_TOKEN: 'facebook_messenger_auth_token',
	SETTINGS_NAME_INSTAGRAM_BUSINESS_ACCOUNT_PREFIX: 'facebook_messenger_instagram_business_account_',
	SETTINGS_NAME_PAGE_TOKEN_PREFIX: 'facebook_messenger_page_token_',
};

export const application_models_Integration_Kixie = {
	SETTING_NAME_KIXIE_ENABLED: 'kixie_enabled',
};

export const application_models_Integration_Twilio = {
	SETTINGS_NAME_AUTH_TOKEN: 'twilio_subaccount_auth_token',
};

export const application_models_User_GoogleSettingsWrapper = {
	ACCESS_TOKEN_SETTING_NAME: 'access_token_kms_envelope',
	CALENDAR_SYNC_ENABLED_SETTING_NAME: 'calendar_sync_enabled',
	ERRORS_SETTING_NAME: 'errors',
	REFRESH_TOKEN_SETTING_NAME: 'refresh_token_kms_envelope',
	SCOPES_SETTING_NAME: 'scopes',
	SETTING_LAST_CALENDAR_FETCH: 'lastcalendarfetch',
	TASKLIST_ID_SETTING_NAME: 'tasklist_id',
	TEMPORARY_CONNECTION_SETTING_NAME: 'temporary_connection',
	USERNAME_SETTING_NAME: 'username',
};

export const application_models_User_Office365SettingsWrapper = {
	ACCESS_TOKEN_ENCRYPTED_SETTING_NAME: 'office_api_access_token_enc',
	ACCESS_TOKEN_KMS_ENVELOPE_SETTING_NAME: 'office_api_access_token_kms_envelope',
	ACCESS_TOKEN_KMS_SETTING_NAME: 'office_api_access_token_kms',
	ACCESS_TOKEN_SETTING_NAME: 'office_api_access_token_kms_envelope',
	DESIRED_PERMISSIONS_SETTING_NAME: 'office_api_desired_permissions',
	ERRORS_SETTING_NAME: 'office_api_errors',
	SCOPES_SETTING_NAME: 'office_api_scopes',
	SETTINGS_CONTACTS_ENABLED: 'contact_sync_office365_enabled',
	SETTINGS_CONTACTS_TOKENS: 'contact_sync_office365_tokens',
	TEMPORARY_CONNECTION_SETTING_NAME: 'office_api_temporary_connection',
	USERNAME_SETTING_NAME: 'office_api_username',
};
